import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=f173cba8&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=f173cba8&lang=scss&"
import style1 from "./edit.vue?vue&type=style&index=1&id=f173cba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f173cba8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f173cba8')) {
      api.createRecord('f173cba8', component.options)
    } else {
      api.reload('f173cba8', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=f173cba8&scoped=true&", function () {
      api.rerender('f173cba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/template/edit.vue"
export default component.exports